import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  removeSyncTarget as removeSyncTargetFromUserGroup
} from 'store/redux/userGroups'

export default function * requestRemoveSyncTargetFromUserGroup (action) {
  const { id, syncTargetId } = action.payload

  const state = yield select()

  const userGroup = state.kanbo.userGroups[id]
  if (!userGroup) return

  const syncTarget = userGroup.syncTargetsById[syncTargetId]
  if (!syncTarget) return

  const optimisticAction = yield optimisticPut(removeSyncTargetFromUserGroup({
    id,
    syncTargetId
  }))

  try {
    yield call(apiAction, 'RemoveSyncTarget', {
      id: syncTargetId
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
